import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import './Modal.css';

export default function Modal({ isOpen, onClose, title, children, maxWidth, width, minHeight, style }) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal-content card animate-slide-up" 
        style={{
          ...(maxWidth ? { maxWidth } : {}),
          ...(width ? { width } : {}),
          ...(minHeight ? { minHeight } : {}),
          ...style
        }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside content
      >
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="icon-button modal-close" onClick={onClose} aria-label="Close Modal">
            <X size={20} />
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}
